module.exports = __webpack_public_path__ + "static/img/fm1.fdaa4d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm1.jpg
// module id = Gmi5
// module chunks = 1